export default __webpack_public_path__ + "static/i-MedicalCard Elite_PDS-e5207cc9218ca5ced31742a8b1bd4a4a.pdf";